async function loadMoreProducts() {
  let products_on_page = document.querySelector(".products-on-page");
  let productNextUrl = document.querySelector("#product-grid");
  let next_url = products_on_page.dataset.nextUrl;
  let load_more_btn = document.querySelector(".load-more_btn");
  let load_more_spinner = document.querySelector(".load-more_spinner");
  load_more_spinner.style.display = "block";
  load_more_btn.style.display = "none";
  let new_products = document.querySelector(".products-on-page");
  let new_url = new_products.dataset.nextUrl;

  if (new_url.trim()) {
    try {
      const response = await fetch(next_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      const next_page = await response.text();
      load_more_spinner.style.display = "none";
      let parser = new DOMParser();
      let parsedHTML = parser.parseFromString(next_page, "text/html");
      let new_products = parsedHTML.querySelector(".products-on-page");
      let new_url = new_products.dataset.nextUrl;

      if (new_url) {
        load_more_btn.style.display = "block";
      }

      next_url = new_url;
      products_on_page.innerHTML += new_products.innerHTML;
      productNextUrl.dataset.nextUrl = next_url;
    } catch (error) {
      console.error("Error loading more products:", error.message);
    }
  } else {
    document.querySelector(".load-more").style.display = "none";
  }
}
